import React from 'react';

let Spacer = ({ px }) => {
    return (
        <div style={{height: `${px}px`}}></div>
    )
}

export default Spacer